import { useQuery } from 'react-query';

import * as authService from 'resources/auth/auth.service';

import userService from 'resources/user/user.service';

const loadInvitedUser = async () => {
  const authUser = authService.getAuth();

  if (!authUser) {
    return null;
  }

  const user = await userService.findByEmail(authUser.email);

  if (!user) {
    return null;
  }

  const realtors = user.realtor_ids?.length
    ? await userService.getUsersByIds(user.realtor_ids)
    : [];

  const promises = realtors.map(userService.attachAvatarUrl);

  const realtorsWithUrl = await Promise.all(promises);

  return { ...user, realtors: realtorsWithUrl };
};

export default function useInvitedUser() {
  return useQuery('user.invitedUser', loadInvitedUser);
}
